import { render, staticRenderFns } from "./Datareport.vue?vue&type=template&id=19a7c424&scoped=true&"
import script from "./Datareport.vue?vue&type=script&lang=js&"
export * from "./Datareport.vue?vue&type=script&lang=js&"
import style0 from "./Datareport.vue?vue&type=style&index=0&id=19a7c424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7c424",
  null
  
)

export default component.exports